import {Component, OnInit} from '@angular/core';
import 'rxjs';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ErrorModalComponent} from '../error-modal/error-modal.component';
import {SuccessModalComponent} from '../success-modal/success-modal.component';
import {GetDataService} from './get-data.service';
import {DeleteModalComponent} from '../delete-modal/delete-modal.component';
import {DataSharingService} from '../data-sharing.service';

@Component({
  selector: 'pm-users-management',
  templateUrl: './users-management.component.html',
  styleUrls: ['../upload-file/upload-file.component.css',
    '../home/welcome.component.css', '../error-modal/error-modal.component.css', '../app.component.css',
    './users-management.component.css', '../file_transfer/ui-report.component.css']
})
export class UsersManagementComponent implements OnInit {
  ifcheckedrow: boolean = true;
  CreateUser: any;
  emailID: any = '';
  firstNameUser: any = '';
  lastNameUser: any = '';
  emailIdEdit: any = '';
  firstNameUserEdit: any = '';
  lastNameUserEdit: any = '';
  emailcheck: boolean = false;
  disableEmailFlag: boolean = true;
  fnameCheck: boolean = false;
  lnamecheck: boolean = false;
  editForm: boolean = true;
  updateForm: boolean = false;
  private _createUserUrl;
  private detailsBody: any;
  modalRef: any;
  successMessage: any;
  errorMessage: any;
  selectedEntry: any;
  users: any[] = [];
  selectedRow: Number;
  setClickedRow: Function;
  setClickedRowDelete: Function;
  emailEdit: string = '';
  fnameEdit: string = '';
  lnameEdit: string = '';
  idEdit: number;
  aditionalinfoEdit: any;
  authorityEdit: any;
  userDetails: any;
  additionalInfo: any;
  usersCount: any = 0;
  pageCount: number;  // no of pages
  pageNumber: number[] = []; // page number array e,g: 1,2,3,4,5
  currentPage: number = 1;
  pageSize: string;
  pageNum: number;
  i: number;
  authoritycheck: any;
  deleteUser: any;
  ifcheckedrowdelete: boolean = true;
  role: any = 'Standard';
  businessPartner: any = '';
  fileFormat: any = 'Standard';
  activated: any = null;
  userRoleLogIn: any;
  businessPartnerEdit: any;
  roleEdit: any = 'Standard';
  fileFormatEdit: any;
  options: any;
  fileFormatEditUpdate: any;
  additionalInfoAdmin: any;

  patternemail = /^[_a-zA-Z0-9-]+(\.[_a-zA-Z0-9-]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*(\.[a-zA-Z]{2,4})$/;
  pattern = /^[^-\s][a-zA-Z-'žšÀÈÌÒÙàèìòùæÆøØåÅæÆøØåÅåÅäÄöÖ ]{1,30}$/;
  patternlname = /^[^-\s][a-zA-Z-'žšÀÈÌÒÙàèìòùæÆøØåÅæÆøØåÅåÅäÄöÖ ]{1,30}$/;

  onSelectionChange(entry) {
    this.selectedEntry = Object.assign({}, this.selectedEntry, entry);
  }

  checkEmail(emailValue) {
    const pattern = /^[_a-zA-Z0-9-]+(\.[_a-zA-Z0-9-]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*(\.[a-zA-Z]{2,4})$/;
    this.emailcheck = !(pattern.test(emailValue));

  }

  checkFname(fnameValue) {
    const pattern = /^[^-\s][a-zA-Z-'žšÀÈÌÒÙàèìòùæÆøØåÅæÆøØåÅåÅäÄöÖ ]{1,30}$/;
    this.fnameCheck = !(pattern.test(fnameValue));
  }

  checkLname(lnameValue) {
    const pattern = /^[^-\s][a-zA-Z-'žšÀÈÌÒÙàèìòùæÆøØåÅæÆøØåÅåÅäÄöÖ ]{1,30}$/;
    this.lnamecheck = !(pattern.test(lnameValue));
  }

  createAdmin(email, fname, lname) {
    this.emailcheck = !(this.patternemail.test(email));
    this.fnameCheck = !(this.pattern.test(fname));
    this.lnamecheck = !(this.patternlname.test(lname));
    if (this.businessPartner === undefined || this.businessPartner === '') {
      this.businessPartner = '';
    }
    if (this.role === 'Administrator') {
      this.role = 'ROLE_PARTNER_ADMIN';
    } else {
      this.role = 'ROLE_PARTNER_USER';
    }
    if (this.fileFormat === 'Standard') {
      this.fileFormat = 'standard';
      if (this.businessPartner.length > 0) {
        this.additionalInfo = this.businessPartner.split(' ')[0] + ',' + this.fileFormat;
      }
    } else if (this.fileFormat === 'Cadimar') {
      this.fileFormat = 'cadimar';
      if (this.businessPartner.length > 0) {
        this.additionalInfo = this.businessPartner.split(' ')[0] + ',' + this.fileFormat;
      }
    }
    if (this.patternemail.test(email) && this.pattern.test(fname) && this.patternlname.test(lname)) {
      this.detailsBody = {
        'login': email,
        'authorities': [
          this.role
        ],
        'email': email,
        'additionalInfo': this.additionalInfo,
        'firstName': fname,
        'lastName': lname
      };
      this._userService.createUser(this.detailsBody)
        .subscribe(data => {
            this.modalRef = this.modalService.open(SuccessModalComponent,
              {size: 'sm', backdrop: 'static', keyboard: false, windowClass: 'sucessModal'}).componentInstance;
            this.modalRef.updateUsers = true;
            this.successMessage = 'Creation successful. An email has been' + '<br>' + 'sent to the user for password setup.';
            this.modalRef.modalText = this.successMessage;
            this.modalRef.modcontent = this.successMessage;
            this.emailID = '';
            this.modalRef.options = this.options;
            this.resetUserInfo();
          },
          error => {
            if (error.status === 400) {
              this.modalRef = this.modalService.open(ErrorModalComponent,
                {size: 'sm', backdrop: 'static', keyboard: false, windowClass: 'test'}).componentInstance;
              this.errorMessage = error.error.title;
              this.modalRef.modalText = this.errorMessage;
              this.modalRef.modcontent = this.errorMessage;
            }
            this.role = 'Standard';
            this.emailID = '';
            this.firstNameUser = '';
            this.lastNameUser = '';
            this.userDetails = '';
            this.businessPartner = '';
            this.fileFormat = 'Standard';
            this.role = 'Standard';
          });
    } else {
      this.emailID = email;
      this.firstNameUser = fname;
      this.lastNameUser = lname;
      this.businessPartner = '';
      this.fileFormat = 'Standard';
      this.role = 'Standard';
    }
  }

  constructor(private modalService: NgbModal, private _userService: GetDataService, private _usersRefresh: DataSharingService,
              private _data: DataSharingService) {
    this.users = [];
    this.usersCount = 0;
    this.businessPartner = '';
    this.setClickedRow = function (user, index) {
      this.selectedRow = index;
      this.ifcheckedrow = false;
      this.fnameEdit = user.firstName;
      this.lnameEdit = user.lastName;
      this.emailEdit = user.email;
      this.idEdit = user.id;
      this.aditionalinfoEdit = user.additionalInfo;
      this.authorityEdit = user.authorities;
      this.roleEdit = user.authorities;
      this.businessPartnerEdit = user.additionalInfo.split(',')[0];
      this.fileFormatEdit = user.additionalInfo.split(',')[1];
      this.fileFormatEditUpdate = this.fileFormatEdit.charAt(0).toUpperCase() + this.fileFormatEdit.slice(1);
    };

    this.setClickedRowDelete = function (user, index) {
      this.selectedRow = index;
      this.ifcheckedrowdelete = false;
      this.deleteUser = user;
    };
  }

  delete_user_info() {
    this.selectedRow = null;
    this.modalRef = this.modalService.open(DeleteModalComponent, {
      backdrop: 'static',
      keyboard: false
    }).componentInstance;
    this.modalRef.modalText = 'Do you really want to delete this user? All\
 its files uploaded and reports will be accessible by Administrator only.';
    this.modalRef.modcontent = 'This action is irreversible';
    this.modalRef.deleteUserInfo = this.deleteUser;
    this.modalRef.options = this.options;
    this.ifcheckedrowdelete = true;

  }

  editInfo() {
    this.editForm = false;
    this.updateForm = true;
  }

  getAllUser() {
    this.editForm = true;
    this.updateForm = false;
    this.fnameCheck = false;
    this.lnamecheck = false;
    this.emailcheck = false;
    this.selectedRow = null;
    this.pageNumber = [];
    this.ifcheckedrow = true;
    this.ifcheckedrowdelete = true;
    this._userService.getUser('0')
      .subscribe((report: Response) => {
          this.manageGetUserResponse(report);
          this.managePagination();
        },
        error => this.errorMessage = <any>error);
    this.currentPage = 1;

  }

  private managePagination() {
    if (this.usersCount % 10 > 0) {
      this.pageCount = Math.trunc(this.usersCount / 10 + 1);
    } else {
      this.pageCount = this.usersCount / 10;
    }
    if (this.pageCount < 6) {
      for (this.i = 1; this.i < this.pageCount + 1; this.i++) {
        this.pageNumber.push(this.i);
      }
    } else {
      for (this.i = 1; this.i < 6; this.i++) {
        this.pageNumber.push(this.i);
      }
    }
  }

  private manageGetUserResponse(report: Response) {
    this.users = [];
    for (let key = 0; key < Object.keys(report.body).length; key++) {
      this.manageOptionList(report, key);
      if (this.users[key].authorities[0] === 'ROLE_PARTNER_USER') {
        this.users[key].authorities = 'Standard';
      } else if (this.users[key].authorities[0] === 'ROLE_PARTNER_ADMIN') {
        this.users[key].authorities = 'Administrator';
      } else {
        this.users[key].authorities = 'Super Admin';
      }
    }
    this.usersCount = report.headers.get('X-Total-Count');
  }

  updateUserInfo(email, fname, lname) {
    this.emailcheck = !(this.patternemail.test(email));
    this.fnameCheck = !(this.pattern.test(fname));
    this.lnamecheck = !(this.patternlname.test(lname));
    if (this.businessPartnerEdit === undefined || this.businessPartner === '') {
      this.businessPartner = '';
    }
    const roleEdit = this.roleEdit;
    const fileFormatEdit = this.fileFormatEditUpdate;
    if (this.roleEdit === 'Administrator') {
      this.roleEdit = ['ROLE_PARTNER_ADMIN'];
    } else {
      this.roleEdit = ['ROLE_PARTNER_USER'];
    }
    if (fileFormatEdit === 'Standard') {
      this.fileFormatEdit = 'standard';
      if (this.businessPartnerEdit.length > 0) {
        this.additionalInfo = this.businessPartnerEdit.split(' ')[0] + ',' + this.fileFormatEdit;
      }
    } else if (fileFormatEdit === 'Cadimar') {
      this.fileFormatEdit = 'cadimar';
      if (this.businessPartnerEdit.length > 0) {
        this.additionalInfo = this.businessPartnerEdit.split(' ')[0] + ',' + this.fileFormatEdit;
      }
    }
    if (this.patternemail.test(email) && this.pattern.test(fname) && this.patternlname.test(lname)) {
      this.detailsBody = {
        'login': email,
        'authorities': this.roleEdit,
        'id': this.idEdit,
        'email': email,
        'additionalInfo': this.additionalInfo,
        'firstName': fname,
        'lastName': lname,
        'activated': true,
        'langKey': 'en'
      };
      this.roleEdit = roleEdit;
      this.fileFormatEdit = fileFormatEdit;
      this._userService.updateUser(this.detailsBody)
        .subscribe(data => {
            this.modalRef = this.modalService.open(SuccessModalComponent,
              {size: 'sm', backdrop: 'static', keyboard: false, windowClass: 'sucessModal'}).componentInstance;
            this.roleEdit = roleEdit;
            this.fileFormatEdit = fileFormatEdit;
            this.modalRef.updateUsers = true;
            this.successMessage = 'Edition successful';
            this.modalRef.modalText = this.successMessage;
            this.modalRef.modcontent = this.successMessage;
            this.modalRef.options = this.options;
            this.selectedRow = null;
            this.ifcheckedrow = true;
            this.getAllUser();
          },
          error => {
            this.roleEdit = roleEdit;
            this.fileFormatEdit = fileFormatEdit;
            if (error.status === 400) {
              this.modalRef = this.modalService.open(ErrorModalComponent,
                {size: 'sm', backdrop: 'static', keyboard: false, windowClass: 'test'}).componentInstance;
              this.errorMessage = error.error.title;
              this.modalRef.modalText = this.errorMessage;
              this.modalRef.modcontent = this.errorMessage;
              this._userService.getUser('0')
                .subscribe((report: Response) => {
                  this.users = [];
                  for (let key = 0; key < Object.keys(report.body).length; key++) {
                    this.manageOptionList(report, key);
                    if (this.users[key].authorities[0] === 'ROLE_PARTNER_USER') {
                      this.users[key].authorities = 'Standard';
                    } else if (this.users[key].authorities[0] === 'ROLE_PARTNER_ADMIN') {
                      this.users[key].authorities = 'Administrator';
                    }
                    this.ifcheckedrow = true;
                  }
                });
              this.editForm = true;
              this.updateForm = false;
            } else {
              this.modalRef = this.modalService.open(ErrorModalComponent,
                {size: 'sm', backdrop: 'static', keyboard: false, windowClass: 'test'}).componentInstance;
              this.errorMessage = 'Internal Error Occured. Please try after some time';
              this.modalRef.modalText = this.errorMessage;
              this.modalRef.modcontent = this.errorMessage;
              this._userService.getUser('0')
                .subscribe((report: Response) => {
                  this.manageGetUserResponse(report);
                });
              this.editForm = true;
              this.updateForm = false;
              this.ifcheckedrow = true;
            }
            this.ifcheckedrow = true;
            this.currentPage = 1;
          }
        );
    } else {
      this.roleEdit = roleEdit;
      this.fileFormatEdit = fileFormatEdit;
    }
  }

  ngOnInit() {
    this.businessPartner = '';
    this.ifcheckedrow = true;
    this.ifcheckedrowdelete = true;
    this._usersRefresh.currentUser.subscribe(users => this.users = users);
    this._usersRefresh.paginationDiv.subscribe(usersCount => this.usersCount = usersCount);
    this._usersRefresh.paginationDelete.subscribe(pageNumber => this.pageNumber = pageNumber);
    this._usersRefresh.pageCountValue.subscribe(pageCount => this.pageCount = pageCount);
    this._usersRefresh.firstPageNum.subscribe(currentPage => this.currentPage = currentPage);
    this._userService.getAdminInfo()
      .subscribe(userDetails => {
          this.userDetails = userDetails;
          this.additionalInfo = this.userDetails.additional_info;
          this.additionalInfoAdmin = this.userDetails.additional_info;
          this.activated = this.userDetails.additional_info;
          if (this.userDetails.authorities[0] === 'ROLE_SUPER_ADMIN') {
            this.authoritycheck = true;
            this.userRoleLogIn = 'SuperAdmin';
          } else {
            this.authoritycheck = false;
          }
        },
        err => {
        }
      );
    this.users = [];
    this.usersCount = 0;
    this._userService.getUser('0')
      .subscribe((report: Response) => {
        this.users = [];
        for (let key = 0; key < Object.keys(report.body).length; key++) {
          this.users.push(report.body[key]);
          if (this.users[key].additionalInfo !== null) {
            for (let optionlist = 0; optionlist < Object.keys(this.options || {}).length; optionlist++) {
              if ((this.users[key].additionalInfo.split(',')[0]) === this.options[optionlist].split(' ')[0]) {
                const file_format = this.users[key].additionalInfo.split(',')[1];
                this.users[key].additionalInfo = this.options[optionlist] + ',' + file_format;
              }
            }
          }
          if (this.users[key].authorities[0] === 'ROLE_PARTNER_USER') {
            this.users[key].authorities = 'Standard';
          } else if (this.users[key].authorities[0] === 'ROLE_PARTNER_ADMIN') {
            this.users[key].authorities = 'Administrator';
          } else {
            this.users[key].authorities = 'Super Admin';
          }
        }
        this.usersCount = 0;
        this.usersCount = report.headers.get('X-Total-Count');
        this.managePagination();
      });
    this.businessPartner = '';
    this._userService.getDropDownPartners()
      .subscribe(dropdownList => {
          this.options = [];
          this.businessPartner = '';
          for (let key = 0; key < dropdownList.length; key++) {
            const optionList = dropdownList[key].code + ' - ' + dropdownList[key].name;
            this.businessPartner = '';
            this.options.push(optionList);
            this.options.sort();
            this.businessPartner = '';
          }
          this.businessPartner = '';
        },
        err => {
        });
  }

  loadUsers(event, num: number) {
    this.ifcheckedrow = true;
    this.ifcheckedrowdelete = true;
    const target = event.target || event.srcElement || event.currentTarget;
    const idAttr = target.attributes.id;
    const value = idAttr.nodeValue;
    this.currentPage = num;
    this.selectedRow = null;
    this._userService.getUser((num - 1).toString())
      .subscribe((report: Response) => {
          this.manageGetUserResponse(report);
        },
        error => this.errorMessage = <any>error);
    for (this.i = 1; this.i < 6; this.i++) {
      if (document.getElementById('page-num-' + this.i) != null) {
        document.getElementById('page-num-' + this.i).className =
          document.getElementById('page-num-' + this.i).className
            .replace(new RegExp('(?:^|\\s)' + 'active-anchor' + '(?:\\s|$)'), ' ');
      }

    }
    event.target.classList.add('active-anchor');
    this.ifcheckedrow = true;
    this.ifcheckedrowdelete = true;
  }

  PreviousClick(pageNum: any) {
    return this.currentPage === 1;
  }

  NextClick(pageNum: any) {
    return this.currentPage === this.pageCount;
  }

  previousClickAction(pageNo: any) {
    if (this.currentPage <= this.pageCount) {
      if (pageNo[0] === this.currentPage) {
        this.pageNumber = [];
        this.i = 1;
        for (this.i = 0; this.i < 5; this.i++) {
          pageNo[this.i] = pageNo[this.i] - 1;
          this.pageNumber.push(pageNo[this.i]);
          this.pageNum = (pageNo[this.i] - 4);
        }
        for (this.i = 1; this.i < 6; this.i++) {
          document.getElementById('page-num-' + this.i).className =
            document.getElementById('page-num-' + this.i).className
              .replace(new RegExp('(?:^|\\s)' + 'active-anchor' + '(?:\\s|$)'), ' ');
        }
        this._userService.getUser((this.pageNum - 1).toString())
          .subscribe((report: Response) => {
              this.users = [];
              for (let key = 0; key < Object.keys(report.body).length; key++) {
                this.manageOptionList(report, key);
                if (this.users[key].authorities[0] === 'ROLE_PARTNER_USER') {
                  this.users[key].authorities = 'Standard';
                } else if (this.users[key].authorities[0] === 'ROLE_PARTNER_ADMIN') {
                  this.users[key].authorities = 'Administrator';
                } else if (this.users[key].authorities[0] === 'ROLE_SUPER_ADMIN') {
                  this.users[key].authorities = 'Super Admin';
                }
              }
              this.usersCount = report.headers.get('X-Total-Count');
            },
            error => this.errorMessage = <any>error);
      } else {
        this._userService.getUser((this.currentPage - 2).toString())
          .subscribe((report: Response) => {
              this.manageGetUserResponse(report);
            },
            error => this.errorMessage = <any>error);
      }
      this.selectedRow = null;
      this.ifcheckedrow = true;
      this.ifcheckedrowdelete = true;
      this.currentPage = this.currentPage - 1;
    }
  }

  private manageOptionList(report: Response, key: number) {
    this.users.push(report.body[key]);
    if (this.users[key].additionalInfo !== null) {
      for (let optionlist = 0; optionlist < Object.keys(this.options).length; optionlist++) {
        if ((this.users[key].additionalInfo.split(',')[0]) === this.options[optionlist].split(' ')[0]) {
          const file_format = this.users[key].additionalInfo.split(',')[1];
          this.users[key].additionalInfo = this.options[optionlist] + ',' + file_format;
        }
      }
    }
  }

  nextClickAction(pageNo: any) {
    if (pageNo[4] === this.currentPage) {
      this.pageNumber = [];
      this.i = 1;
      for (this.i = 0; this.i < 5; this.i++) {
        pageNo[this.i] = pageNo[this.i] + 1;
        this.pageNumber.push(pageNo[this.i]);
        this.pageNum = (pageNo[this.i]);
      }
      for (this.i = 1; this.i < 6; this.i++) {
        document.getElementById('page-num-' + this.i).className =
          document.getElementById('page-num-' + this.i).className
            .replace(new RegExp('(?:^|\\s)' + 'active-anchor' + '(?:\\s|$)'), ' ');
      }
      this._userService.getUser((this.pageNum - 1).toString())
        .subscribe((report: Response) => {
            this.users = [];
            for (let key = 0; key < Object.keys(report.body).length; key++) {
              this.manageOptionList(report, key);
              if (this.users[key].authorities[0] === 'ROLE_PARTNER_USER') {
                this.users[key].authorities = 'Standard';
              } else if (this.users[key].authorities[0] === 'ROLE_PARTNER_ADMIN') {
                this.users[key].authorities = 'Administrator';
              }
            }
            this.usersCount = report.headers.get('X-Total-Count');
          },
          error => this.errorMessage = <any>error);
    } else {
      this._userService.getUser((this.currentPage).toString())
        .subscribe((report: Response) => {
            this.manageGetUserResponse(report);
          },
          error => this.errorMessage = <any>error);
    }
    this.selectedRow = null;
    this.ifcheckedrow = true;
    this.ifcheckedrowdelete = true;
    this.currentPage = this.currentPage + 1;
  }

  returnPageNum() {
    return this.currentPage;
  }

  NewUser() {
    this.emailID = '';
    this.fnameCheck = false;
    this.lnamecheck = false;
    this.emailcheck = false;
    this.resetUserInfo();
  }

  private resetUserInfo() {
    this.firstNameUser = '';
    this.lastNameUser = '';
    this.userDetails = '';
    this.businessPartner = '';
    this.fileFormat = 'Standard';
    this.role = 'Standard';
    this.businessPartner = '';
  }
}
